import React, { useState, useEffect } from "react";
import uuid from "react-uuid";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import CustomSelect from "components/Input/CustomSelect.js";
import { TextInput, IntInput } from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { eventtext } from "variables/MBM/schedule";
import { daysofweekData, lightStateData } from "variables/MBM/lists/schedule";
import { controltypeData } from "variables/MBM/lists/equipments";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
  submitButtonDelete: {
    color: "#FFFFFF",
    backgroundColor: "#F44336",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#F44336",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;




function DefaultWeekEventDialog(props) {

  const timeformat = (hours, minute) => {
    let formated = new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(hours);
    formated += ":";
    formated += new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(minute);
    return formated;
  }
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const { closeModal, refetch, scheduletype, existingevents, setExistingevents, editedevent, controltype, availablemodes } = props;
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [name, setName] = useState(editedevent.name || "");
  const [startDay, setStartDay] = useState(editedevent.startDay);
  const [startTime, setStartTime] = useState(editedevent.startTime);
  const [endDay, setEndDay] = useState(editedevent.endDay);
  const [endTime, setEndTime] = useState(editedevent.endTime);
  const [value, setValue] = useState(editedevent.value);
  const [controlid, setControlid] = useState(editedevent.controlid);

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleStartDayChange = (event) => {
    if (!validStart(event.target.value, startTime))
      return;
    if (convertToTotalMinutes(event.target.value, startTime) + 5 > convertToTotalMinutes(endDay, endTime)) {
      setEndTimePlus5(event.target.value, startTime);
    }
    setStartDay(event.target.value);
  };
  const handleStartTimeChange = (event) => {
    if (!validStart(startDay, event.target.value))
      return;
    if (convertToTotalMinutes(startDay, event.target.value) + 5 > convertToTotalMinutes(endDay, endTime)) {
      setEndTimePlus5(startDay, event.target.value);
    }
    setStartTime(event.target.value);
  };
  const handleEndDayChange = (event) => {
    if (!validEnd(event.target.value, endTime))
      return;
    if (convertToTotalMinutes(event.target.value, endTime) - 5 < convertToTotalMinutes(startDay, startTime)) {
      setStartTime(endTime);
      setStartDay(event.target.value);
    }
    setEndDay(event.target.value);
  };
  const handleEndTimeChange = (event) => {
    if (!validEnd(endDay, event.target.value))
      return;
    if (convertToTotalMinutes(endDay, event.target.value) - 5 < convertToTotalMinutes(startDay, startTime)) {
      setEndTime(event.target.value);
      setEndDay(endDay);
    }
    setEndTime(event.target.value);
  };
  const handleValueChange = (event) => {
    if (scheduletype === "temperature") {
      if (event.target.value < 0 || event.target.value > 100)
        return;
      setValue(event.target.value);
    }
    else if (scheduletype === "equipment") {
      if (controltypeData.find((c) => c.id === controltype).type === 'list') {
        let mode = availablemodes.find((m) => m.id === event.target.value);
        setValue(Number(mode.val));
        setControlid(mode.id);
      }
      else
        setValue(event.target.value);
    }
    else
      setValue(event.target.value);
  };

  const handleSubmitDelete = async (event) => {
    let tmpevents = existingevents;

    if (editedevent.id) //event modification
    {
      let index = tmpevents.findIndex((item) => item.id === editedevent.id);
      if (index >= 0) {
        tmpevents.splice(index, 1); //slice before check otherwise we will have overlap
      }
      setExistingevents(tmpevents);
      closeModal();
    }
  };

  const handleSubmit = async (event) => {
    let tmpevents = existingevents;
    editedevent.name = name;
    editedevent.startDay = startDay;
    editedevent.endDay = endDay;
    editedevent.startTime = startTime;
    editedevent.endTime = endTime;
    editedevent.value = value;
    editedevent.controlid = controlid;
    if (editedevent.id) //event modification
    {
      let index = tmpevents.findIndex((item) => item.id === editedevent.id);
      if (index >= 0) {
        tmpevents.splice(index, 1); //slice before check otherwise we will have overlap
      }
    }
    else //new event
    {
      editedevent.id = uuid();
    }
    let overlap = false;
    let overlapevent = {};
    let neweventstarttotalminutes = convertToTotalMinutes(startDay, startTime);
    let neweventendtotalminutes = convertToTotalMinutes(endDay, endTime);
    existingevents.map((event) => {
      let eventstarttotalminutes = convertToTotalMinutes(event.startDay, event.startTime);
      let eventendtotalminutes = convertToTotalMinutes(event.endDay, event.endTime);
      if ((neweventstarttotalminutes > eventstarttotalminutes && neweventstarttotalminutes < eventendtotalminutes)
        || (neweventendtotalminutes > eventstarttotalminutes && neweventendtotalminutes < eventendtotalminutes)
        || (neweventstarttotalminutes <= eventstarttotalminutes && neweventendtotalminutes >= eventendtotalminutes)) {
        overlap = true;
        overlapevent = { ...event };
      }
    });
    if (overlap) {
      setNotification("error", "L'évennement est en conflit avec l'évennement " + overlapevent.name + " (" + daysofweekData.find((x) => x.id == overlapevent.startDay)?.name
        + " " + overlapevent.startTime + " - " + daysofweekData.find((x) => x.id == overlapevent.endDay)?.name + " " + overlapevent.endTime + ")");
    }
    else {
      tmpevents.push({ ...editedevent });
      setExistingevents(tmpevents);
      closeModal();
    }
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  useEffect(() => {
    if (!name || value === "")
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const validStart = (day, time) => { //Sunday 23:54 max (so that end is Sunday 23:59)
    let valid = true;
    if (!time)
      valid = false;
    else if (day === 0) {
      const timearray = time.split(':');
      let hours = Number(timearray[0]);
      if (hours === 23) {
        let minutes = Number(timearray[1]);
        if (minutes >= 55) {
          valid = false;
        }
      }
    }
    return valid;
  }

  const validEnd = (day, time) => { //Monday 00:05 min (so that start is Monday 00:00)
    let valid = true;
    if (!time)
      valid = false;
    else if (day === 1) {
      const timearray = time.split(':');
      let hours = Number(timearray[0]);
      if (hours === 0) {
        let minutes = Number(timearray[1]);
        if (minutes <= 4) {
          valid = false;
        }
      }
    }
    return valid;
  }

  const setEndTimePlus5 = (day, time) => {
    day = (day + 6) % 7; //from sunday = 0 to sunday = 6;
    const timearray = time.split(':');
    let hours = Number(timearray[0]);
    let minutes = Number(timearray[1]);
    if (minutes >= 55) {
      if (hours >= 23) {
        day = (day + 1) % 7;
      }
      hours = (hours + 1) % 24;
    }
    minutes = (minutes + 5) % 60;
    day = (day + 1) % 7; //from sunday = 6 to sunday = 0;
    setEndTime(timeformat(hours, minutes));
    setEndDay(day);
  }


  const convertToTotalMinutes = (day, time) => {
    day = (day + 6) % 7;
    const timearray = time.split(':');
    const hours = Number(timearray[0]);
    const minutes = Number(timearray[1]) + (hours * 60) + (day * 1440);
    return minutes;
  }


  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={eventtext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={6} lg={6}>
            <div>
              <CustomSelect
                isRequired
                inputTitle={eventtext.startdate}
                selectValue={startDay}
                handleSelectValueChange={handleStartDayChange}
                data={daysofweekData}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={6} lg={6}>
            <div>
              <DateInput
                isRequired
                specialType={"time"}
                inputTitle={eventtext.starttime}
                dateInput={startTime}
                handleDateInputChange={handleStartTimeChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={6} lg={6}>
            <div>
              <CustomSelect
                isRequired
                inputTitle={eventtext.enddate}
                selectValue={endDay}
                handleSelectValueChange={handleEndDayChange}
                data={daysofweekData}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={6} lg={6}>
            <div>
              <DateInput
                isRequired
                specialType={"time"}
                inputTitle={eventtext.endtime}
                dateInput={endTime}
                handleDateInputChange={handleEndTimeChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            {
              scheduletype === "light" ?
                <div>
                  <CustomSelect
                    isRequired
                    inputTitle={eventtext.lightvalue}
                    selectValue={value}
                    handleSelectValueChange={handleValueChange}
                    data={lightStateData}
                    disabled={!mbm_geb_control_schedules}
                  />
                </div>
                : scheduletype === "temperature" ?
                  <div>
                    <IntInput
                      isRequired
                      inputTitle={eventtext.tempvalue}
                      max={100}
                      intInput={value}
                      handleIntInputChange={handleValueChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  : scheduletype === "equipment" ?
                    <div>
                      {
                        controltype && controltypeData.find((c) => c.id === controltype) ?
                          (controltypeData.find((c) => c.id === controltype).type === 'int' ?
                            <IntInput
                              isRequired
                              inputTitle={eventtext.value + " (" + controltypeData.find((c) => c.id === controltype).unit + ")"}
                              max={100}
                              intInput={value}
                              handleIntInputChange={handleValueChange}
                              disabled={!mbm_geb_control_schedules}
                            /> : controltypeData.find((c) => c.id === controltype).type === 'list' ? <CustomSelect
                              inputTitle={eventtext.value}
                              selectValue={controlid}
                              handleSelectValueChange={handleValueChange}
                              data={availablemodes}
                              disabled={!mbm_geb_control_schedules}
                            /> : <></>
                          ) : <></>
                      }
                    </div>
                    :
                    <div>
                      <TextInput
                        isRequired
                        inputTitle={eventtext.freevalue}
                        textInput={value}
                        handleTextInputChange={handleValueChange}
                        disabled={!mbm_geb_control_schedules}
                      />
                    </div>
            }

          </GridItem>
          {editedevent.id && mbm_geb_control_schedules &&
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Button
                disabled={buttonDisabled}
                className={
                  buttonDisabled
                    ? classes.submitButtonDisabled
                    : classes.submitButtonDelete
                }
                onClick={() => {
                  handleSubmitDelete();
                }}
              >
                Supprimer
              </Button>
            </GridItem>
          }
          {mbm_geb_control_schedules &&
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Button
                disabled={buttonDisabled}
                className={
                  buttonDisabled
                    ? classes.submitButtonDisabled
                    : classes.submitButton
                }
                onClick={() => {
                  handleSubmit();
                }}
              >
                Enregistrer
              </Button>
            </GridItem>
          }
        </GridContainer>
      </form>
    </>
  );
}

export default DefaultWeekEventDialog;
